import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputFieldComponent } from './form-input-field.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormInputFieldComponent
  ],
  exports: [
    FormInputFieldComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ]
})
export class FormInputFieldModule { }
